import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { IconButton } from '../../design-system/utils'

export const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: ${(p) => p.theme.headerHeight};
  position: sticky;
  top: 0;
  background: ${(p) => p.theme.colors.white};
  z-index: 10;
  padding: ${(p) => p.theme.spacing.sm} ${(p) => p.theme.spacing.xl};
  border-bottom: 1px solid ${(p) => p.theme.colors.grays[2]};

  .logo {
    max-width: 160px;
    height: auto;
    display: block;
  }
`

export const NavContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${(p) => p.theme.spacing.md};
`

export const NavItem = styled(Link)<{ selected: boolean }>`
  font-size: 14px;
  color: inherit;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  transition: color ${(p) => p.theme.duration.default};

  &:hover {
    color: ${(p) => p.theme.colors.primary};
  }

  ${(p) =>
    p.selected &&
    `
    color: ${p.theme.colors.primary};
	font-weight: 700;
    border-bottom-color: ${p.theme.colors.primary};
  `}
`

export const LogoutButton = styled(IconButton)`
  color: inherit;
  transition: ${(p) => p.theme.duration.default};

  &:hover,
  &:focus {
    color: ${(p) => p.theme.colors.primary};
    opacity: 0.7;
  }
`
